import React, { Component } from 'react';

class RadioButton extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let NuevaSolicitudAdministradoraRadio;
        let me = this;

        let administradoraSeleccionadaId = this.props.administradoraSeleccionada;
        let tarjetasIconos = {
            V: "icon-visa fa-2x",
            C: "image-cabal-logo-large",
            M: "icon-visa fa-3x"
        }


        NuevaSolicitudAdministradoraRadio = this.props.tarjetas.map(function (rowAdm) {
            let checked = (administradoraSeleccionadaId == rowAdm.Id) ? true : false;
            let classSelected = checked ? "selected" : "";
            let disabledProp = { disabled: "disabled" };
           
            return (
                <div className="row">
                    <div className={"col-md-12 bottom-separator separator-light " + classSelected} key={"Administrator_" + rowAdm.Id}>
                        <div onClick={() => { me.handleClick(rowAdm) }} className="container-radio radio-margin">
                            <input type="radio" name="rb" id={rowAdm.Id} checked={checked}
                                onClick={() => { me.handleClick(rowAdm) }}
                            ></input>

                            <label className="lbl-radio label-secondary" htmlFor={rowAdm.Id}><label className={tarjetasIconos[rowAdm.Abreviatura]}></label></label>
                        </div>
                    </div>
                </div>
            );
        })

        return (
            
                <div className="container-fluid bottom-separator-marca">
                    {NuevaSolicitudAdministradoraRadio}
                </div>
            
        )
    }

    handleClick(data) {
        this.props.selectRadioButton(data.Id, data.Descripcion, data.Abreviatura);
    }

};

export default RadioButton